"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidPlaceholder = void 0;
var _xDataGridPro = require("@mui/x-data-grid-pro");
var useValidPlaceholder = exports.useValidPlaceholder = function useValidPlaceholder(placeholder, rowNode) {
  try {
    var _useGridRootProps = (0, _xDataGridPro.useGridRootProps)(),
      _useGridRootProps$tre = _useGridRootProps.treeDataWithGaps,
      treeDataWithGaps = _useGridRootProps$tre === void 0 ? false : _useGridRootProps$tre;
    var depth = rowNode.depth;
    return treeDataWithGaps && depth > 0 ? '' : placeholder;
  } catch (e) {
    console.error(e);
    return placeholder;
  }
};